// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'whatwg-fetch'
import Vue from 'vue'
import Vuex from 'vuex'
import { sync } from 'vuex-router-sync'
import VeeValidate from 'vee-validate'
import VueLazyload from 'vue-lazyload'
import { Howl, Howler } from 'howler';

import '@modernizr'
import Scrollbar from '@/scripts/scrollbar'

import App from './App'
import router from './router'
import store from './store'
import { getDevice, isMobile } from './scripts/utils'
import './style.scss'

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueLazyload, { preLoad: 0.7 })
Vue.use(Scrollbar)
Vue.use(VeeValidate)
// Vue.use(VueTouch, { name: 'v-touch' })

sync(store, router)
Vue.config.productionTip = false


const hoverSound = new Howl({
  src: ['/static/hover.mp3'],
  autoplay: false,
  loop: false,
  volume: 0.1,
});

Vue.prototype.$hover = () => {
  hoverSound.play();
};

Vue.mixin({
  methods: {
    getDevice,
    isMobile,
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

Vue.filter('capitalize', (value) => {
  if (!value) return ''
  const val = value.toString()
  return val.charAt(0).toUpperCase() + val.slice(1)
});


// WEBPACK FOOTER //
// ./src/main.js